import axios from "axios";
import cookies from 'js-cookie';
import method from "@/Library/method.js";
import { ElNotification } from 'element-plus';


//创建一个axios实例
const api = axios.create({
    baseURL: process.env.VUE_APP_BASE_API,
    timeout: 120000 // 请求超时时间
});


//请求前数据处理
api.interceptors.request.use(
    config => {

        //创建表单对象，组装接口调用数据，用于提交接口访问数据
        let form = new FormData();
        let data=config.data ? config.data : {};
        data.timestamp=new Date().getTime();
        data.sign=method.GetSign(data); //获取签名
        data.act=config.act;
        data.token=cookies.get('token') ? cookies.get('token') : '';

        //组装过滤提交参数，为空字符串或空的直接过滤
        for(let key in data) {
            data[key]!=='undefined' && data[key]!=null && data[key]!=='' ?
            form.append(key,data[key]) : '';
        }
        
        config.data=form;
        return config;
    },
    error => {
        // 请求错误处理
        console.log(error); 
        return Promise.reject(error);
    }
);


//请求成功返回数据处理
api.interceptors.response.use(
    response => {
        const res = response.data;
        //返回错误数据时，进行统一处理
        if(res.status > 0) ElNotification({title:'错误提示',type:'warning',message:res.msg});
        return res;
    },
    error => {
        // 响应错误处理
        console.log('err' + error); 
        return Promise.reject(error);
    }
);
  
export default api;